<template>
  <transition name="fade">
    <div v-if="showTag" class="v-msg l0 r0 b90 fixed pl30 pr30">
      <span class="block color_fff radius20 pb15 pt15 center fs16">{{text}}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'v-msg',
  props: {
    delay: { type: Number, default: 3000 }
  },
  data () {
    return {
      text: '',
      showTag: false
    }
  },
  methods: {
    show (txt, cb) {
      this.text = txt
      this.showTag = true
      setTimeout(this.hide.bind(this, cb), this.delay)
    },
    hide (cb) {
      this.showTag = false
      cb && cb()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/public";

.v-msg {
  z-index: 100000;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
 {
  opacity: 0;
  transform: translateY(100%);
}

span {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/common/v-msg.vue